"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MeterPerHour = exports.KilometerPerHour = exports.MilesPerHour = exports.FeetPerMinute = exports.FeetPerSecond = exports.MeterPerSecond = void 0;
// import { Meter, Second } from "./base-units";
var uom_1 = require("uom");
var UnitDivide = require("../unit-divide");
var length_1 = require("./length");
var duration_1 = require("./duration");
/** The metric unit for velocity quantities ( <code>m/s</code> ). */
exports.MeterPerSecond = UnitDivide.lengthByDuration("MeterPerSecond", uom_1.BaseUnits.Meter, uom_1.BaseUnits.Second);
// Velocity
exports.FeetPerSecond = UnitDivide.lengthByDuration("FeetPerSecond", length_1.Foot, uom_1.BaseUnits.Second);
exports.FeetPerMinute = UnitDivide.lengthByDuration("FeetPerMinute", length_1.Foot, duration_1.Minute);
exports.MilesPerHour = UnitDivide.lengthByDuration("MilesPerHour", length_1.Mile, duration_1.Hour);
exports.KilometerPerHour = UnitDivide.lengthByDuration("KilometerPerHour", length_1.Kilometer, duration_1.Hour);
exports.MeterPerHour = UnitDivide.lengthByDuration("MeterPerHour", uom_1.BaseUnits.Meter, duration_1.Hour);
//# sourceMappingURL=velocity.js.map